module.exports = __webpack_public_path__ + "860b2e70952b0b9aea119d3c82dd2db1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/icons/community-energy-light.png
// module id = 1865
// module chunks = 1